export default {
  'aws.title': 'Amazon Order',
  'aws.business': 'Product/Order ID',
  'aws.orderStatus': 'Order Status',
  'aws.aswStatus': 'Subscription Status',
  'aws.orderInfo': 'Order Information',
  'aws.expireTime': 'Expiration Time',
  'aws.createTime': 'Creation Time',
  'aws.pending': 'Pending Activation',
  'aws.unbind': 'Pending Link',
  'aws.bound': 'Linked',
  'aws.cancelled': 'Cancelled',
  'aws.activeText': 'Activation after {time}',
  'aws.operate': 'Operate',
  'aws.bindTips': 'Order awaiting activation, operation unavailable',
  'aws.bind': 'Bind',
  'aws.engageLabOrder': 'EngageLab Order',
  'aws.whatsapp.recharge': 'Recharge',
  'aws.whatsapp.recharge.price': 'Recharge Amount',
  'aws.apppush.dataCenter': 'Data Center',
  'aws.apppush.dau': 'DAU',
  'aws.apppush.vip': 'VIP Duration',
  'aws.email.tips': 'Email Package/Traffic/Independent IP',
  'aws.email': 'Email Quantity',
  'aws.email.ip': 'Independent IP Quantity',
  'aws.email.flow': 'Recharge Traffic',
  'aws.choose.service': 'Choose EngageLab Service',
  'aws.choose.organization': 'Organization',
  'aws.choose.nodata': 'No Applications Available',
  'aws.choose.whatsapp': 'Business Account',
  'aws.choose.app': 'Application',
  'aws.order.title': 'Bind Amazon Order',
  'aws.order.information': 'Amazon Order Information',
  'aws.order.id': 'Order ID',
  'aws.order.product': 'Product Type',
  'aws.bind.success': 'Linking Successful',
  'aws.bind.modal.create': 'Create {appName}',
  'aws.month': '{number} Months',
  'aws.allBusiness': 'All Products',
  'aws.order.status': 'Order Status',
  'aws.aswStatus.refunded': 'Refunded',
  'aws.aswStatus.expired': 'Expired',
  'aws.aswStatus.subscribed': 'Subscribed',
  'aws.aswStatus.upgraded': 'Upgraded',
  'aws.aswStatus.renewed': 'Auto-Renewed',
  'aws.aswStatus.cancelled': 'Cancelled',
  'aws.aswStatus.refunded.tips':
    'This order has been refunded on Amazon, please contact business for details',
  'aws.aswStatus.upgraded.tips':
    'This order has been upgraded on Amazon. To enjoy the upgraded benefits on EngageLab, please contact sales for assistance. The upgraded package is as follows:',
  'aws.bindTips.cancelled': 'Order has been cancelled on Amazon',
  'aws.bindTips.unbind': 'Order is {status} on Amazon, please contact business for details',
  'aws.bindTips.unbind.status.refunded': 'Refunded',
  'aws.bindTips.unbind.status.expired': 'Expired',
  'aws.bindTips.unbind.status.upgraded': 'Upgraded',
  'aws.bindTips.unbind.status': 'Refunded/Expired/Upgraded',
  'aws.nodata': 'No data available',
  'aws.jumpEmail':
    'Please go to <a href="https://www.engagelab.com/console/email/#/email/{orgid}/sendSetting/domain" target="_blank">Email</a> to configure the domain',
};
